import React from "react";
import CircleIcon from '@mui/icons-material/Circle';



export default function TrafficlightButtonRed() {
return(

    <CircleIcon sx={{fontSize: '170%', color: 'traffic.red' }} />
)
}